import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { GraphQLSubscribe } from '../utils/methods/graphql.subscribe';

@Injectable()
export class CreateProductionNoteSubscription extends GraphQLSubscribe {
	override command: DocumentNode = gql`
		subscription OnCreateProductionNote {
			onCreateProductionNote {
				id
				createdAt
				sequenceNumber
				note
				createdBy
				itemAlias
				batchId
			}
		}
	`;
}
